const volmachtAanvraagBekijken = {

	/**
	 * Initializes the module
	 */
	init() {
		// Disable modal inputs
		this.disableModalInputs(document.querySelectorAll('.modal input'));

		// Handle manual processing checkboxes
		document.querySelectorAll('.modal .handmatig-verwerken').forEach(checkbox => this.toggleHandmatigVerwerken(checkbox));

		// Initialize event listeners
		this.initEvents();

	},

	/**
	 * Initializes all event listeners for the page functionality
	 */
	initEvents() {

		const uploadButton = document.getElementById('fileUploadButton');
		const uploadField = document.getElementById('fileUploadField');
		const opmerkingenOpslaan = document.getElementById('opmerkingenOpslaan');
		const uploadFileForm = document.getElementById('uploadFileForm');

		// Opmerkingen opslaan
		opmerkingenOpslaan.addEventListener('click', () => this.submitOpmerkingen());

		// Upload button
		uploadButton.addEventListener('click', () => uploadField.click());

		// Upload file select
		uploadField.addEventListener('change', () => uploadFileForm.submit());

	},

	/**
	 * Disables all input fields within modal dialogs
	 *
	 * @param {NodeList} inputs - List of input elements to disable
	 */
	disableModalInputs(inputs) {
		inputs.forEach(input => {
			input.setAttribute('disabled', 'true');
		});
	},

	/**
	 * Shows/hides textarea based on checkbox state for manual processing
	 *
	 * @param {HTMLInputElement} checkbox - The manual processing checkbox that triggers the toggle
	 */
	toggleHandmatigVerwerken(checkbox) {
		if (checkbox.checked) {
			const textareaGroup = checkbox.closest('.form-group').querySelector('textarea').closest('.form-group');
			if (textareaGroup.classList.contains('d-none')) {
				textareaGroup.classList.remove('d-none');
			}
		}
	},

	/**
	 * Prepares and submits the comments form by clearing action and target
	 *
	 * @param {HTMLFormElement} form - The comments form element to submit
	 * @param {HTMLInputElement} formAction - The form action input field to clear
	 */
	submitOpmerkingen() {
		document.getElementById('formAction').value = '';
		document.getElementById('opmerkingen').submit();
	}

};

export default volmachtAanvraagBekijken;
